module.exports = __webpack_public_path__ + "img/otopack250-badge.91e0ac47.svg";